import React from "react";
import { Progress } from "reactstrap";
import PropTypes from "prop-types";
import { Tooltip } from "react-tooltip";
import { getFormattedNumber } from "utility/helpers";
import styled from "styled-components";

import "react-tooltip/dist/react-tooltip.css";

const StyledProgress = styled(Progress)`
  height: 30px !important;
  border-radius: 6px !important;
  padding: 0 !important;
`;

const StyledTooltip = styled(Tooltip)`
  background-color: white;
  color: #2e2828;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);
  opacity: 1;
`;

const TooltipLabel = styled.div`
  display: flex;
  justify-content: center;
  font-weight: bold;
`;

const TooltipValue = styled.div`
  display: flex;
  justify-content: center;
`;

const StackedProgressBar = ({ data }) => {
  const getColor = (budget) => {
    // if budget is remaining balance
    if (budget === null) return "#F0F0FF";

    return `#${Math.floor(Math.random() * 16777215).toString(16)}`;
  };

  return (
    <StyledProgress multi>
      {data.length !== 0 &&
        data?.map((bar) => {
          const color =
            bar?.name === "Remaining Balance" ? getColor(null) : getColor();

          return (
            <React.Fragment key={bar.id}>
              <StyledTooltip anchorSelect={`.bar--${bar?.id}`}>
                <TooltipLabel>{bar?.name}</TooltipLabel>

                <TooltipValue>{getFormattedNumber(bar?.value)}</TooltipValue>
              </StyledTooltip>
              <Progress
                bar
                className={`bar--${bar?.id}`}
                id={`bar--${bar?.id}`}
                style={{ backgroundColor: color }}
                value={bar?.budget}
              />
            </React.Fragment>
          );
        })}
    </StyledProgress>
  );
};

export default React.memo(StackedProgressBar);

StackedProgressBar.propTypes = {
  data: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])).isRequired,
};
